import { useEffect, useState, useCallback } from "react";

export const useScrollIndicators = (containerRef, dependencies = []) => {
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;
    const { scrollLeft, scrollWidth, clientWidth } = container;

    setCanScrollLeft(scrollLeft > 0);

    setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
  }, [containerRef]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    checkScroll();

    container.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      container.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, [containerRef, checkScroll, ...dependencies]);

  return { canScrollLeft, canScrollRight };
};
